import { AuthGuard } from "./guards/auth.guard";
import { MatPaginatorIntlPTBR } from "./shared/utils/mat-paginator-intl-pt-br";
import { SharedModule } from "./shared/shared.module";
import { BrowserModule } from "@angular/platform-browser";
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSidenavModule } from "@angular/material/sidenav";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { JwtModule, JWT_OPTIONS } from "@auth0/angular-jwt";
import { NgxMaskModule, IConfig } from "ngx-mask";
import { NgxCurrencyDirective, NgxCurrencyInputMode, provideEnvironmentNgxCurrency } from "ngx-currency";
import { PopupModule } from './shared/popup.module';
import { AuthTokenInterceptor } from './shared/utils/auth-token-interceptor';
import { MatPaginatorIntl } from "@angular/material/paginator";
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";

import { registerLocaleData } from '@angular/common';
import localeBr from '@angular/common/locales/pt';
import { GlobalVariables } from "./shared/utils/global-variables.service";
import { AuthSemMenuGuard } from "./guards/auth-sem-menu.guard";
import { MonacoEditorModule } from "ngx-monaco-editor-v2";
import { SpinnerModule } from "./shared/components/spinner/spinner.module";
import { LoadingInterceptor } from "./shared/utils/loading.interceptor";

registerLocaleData(localeBr, 'pt')

export function jwtOptionsFactory() {
  return {
    tokenGetter: () => {
      const tokenResponse = JSON.parse(window.localStorage.getItem("auth") as string);
      if (tokenResponse) {
        return tokenResponse.token;
      }
    },
    whitelistedDomains: ["localhost:8080", "{PROD_ENV}"],
  };
}

export const options: Partial<IConfig> = {
  decimalMarker: ",",
  validation: false,
  showMaskTyped: true,
};

export const CustomCurrencyMaskConfig = {
  align: "left",
  allowNegative: false,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
  inputMode: NgxCurrencyInputMode.Natural,
  allowZero: true,
  nullable: false
  
};

export function tokenGetter() {
  return localStorage.getItem("jwt_token");
}

export const MY_DATE_FORMAT = {
  display: {
    dateInput: 'DD MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
    declarations: [AppComponent],
    imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    /*StorageServiceModule, -- Verificar*/
    SharedModule,
    MatSidenavModule,
    HttpClientModule,
    JwtModule.forRoot({
        jwtOptionsProvider: {
            provide: JWT_OPTIONS,
            useFactory: jwtOptionsFactory,
        },
    }),
    NgxMaskModule.forRoot(options),
    NgxCurrencyDirective,
    PopupModule,
    MonacoEditorModule.forRoot(),
    SpinnerModule,
],
    providers: [
        AuthGuard,
        AuthSemMenuGuard,
        GlobalVariables,
        { provide: MatPaginatorIntl, useClass: MatPaginatorIntlPTBR },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
        { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
        {
          provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true
        },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: MAT_DATE_LOCALE, useValue: "pt-BR" },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
        provideEnvironmentNgxCurrency(CustomCurrencyMaskConfig),
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}